<!-- 加载失败页面 -->
<template>
    <div class="imgfa" @click="refresh">
        <img class='imgdefault' src="@/assets/images/loadfailed.png" alt="">
        <span class="text">{{$t("common.loadFail")}}</span>
        <slot>
            <div class="refreshbtn">{{$t("common.refresh")}}</div>
        </slot>
    </div>
</template>
<script>
export default {
    name: 'LoadFailed',
    methods: {
        refresh() {
            this.$emit('refresh');
        }
    },
};
</script>
<style lang='less' scoped>
.imgfa {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fff;
    padding: 38px 0;
    width: 100%;
    .imgdefault {
        height: 80px;
        width: 80px;
        margin-bottom: 28px;
    }
    .text {
        color: #2B3447;
        font-size: 16px;
    }
    .refreshbtn {
        margin-top: 16px;
        font-size: 14px;
        color: #818999;
    }
}
</style>